import axios, { AxiosResponse } from 'axios';

import config from '../../../../config/config';
import { IMembershipPlanPriceModel } from '../../../../models/MembershipPlanPriceModel';
import { IPromoCodeInfo } from '../../../../models/PromoCodeInfo';
import {
  QueryParamItem,
  prepareQueryParams,
} from '../../../../utils/validations/queryParamsHelpers';
import { IOrganizationSearchResult } from '../../organizations/api';
import { IPeopleSearchResult } from '../../people/api';

export interface IStandardPricingQueryResponse {
  membershipPlansPrices: IMembershipPlanPriceModel[];
}

export const searchKEOrganization = (
  organizationName?: string,
  organizationId?: string,
  cancellationToken?: AbortSignal,
): Promise<AxiosResponse<IOrganizationSearchResult>> => {
  const queryParams: QueryParamItem[] = [
    {
      name: 'organizationName',
      value: organizationName,
    },
    {
      name: 'organizationId',
      value: organizationId,
    },
  ];
  const params = prepareQueryParams({ queryParams });

  return axios.get(`/api/organizations/search${params}`, {
    baseURL: config.kidnapAndExtortionApi.baseUrl,
    signal: cancellationToken,
  });
};

export const searchKEPerson = (
  email: string,
): Promise<AxiosResponse<IPeopleSearchResult>> =>
  axios.get(`/api/people/search?email=${encodeURIComponent(email)}`, {
    baseURL: config.kidnapAndExtortionApi.baseUrl,
  });

export const searchKEPromoCodesInfo = (
  value: string,
  cancellationToken: AbortSignal,
): Promise<AxiosResponse<IPromoCodeInfo>> =>
  axios.get(`/api/promocodes/${value}/info`, {
    baseURL: config.kidnapAndExtortionApi.baseUrl,
    signal: cancellationToken,
  });

export const getKECountries = (): Promise<AxiosResponse<string[]>> =>
  axios.get(`/api/countries`, {
    baseURL: config.kidnapAndExtortionApi.baseUrl,
  });
